import * as React from "react";
import styled from "styled-components";
export var StyledTableRow = styled(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTest = _ref.dataTest;
  return React.createElement("tr", {
    className: className,
    "data-test": dataTest
  }, children);
}).withConfig({
  displayName: "TableRow__StyledTableRow",
  componentId: "nnt9s9-0"
})(["box-sizing:border-box;width:100%;white-space:nowrap;"]);

var TableRow = function TableRow(_ref2) {
  var dataTest = _ref2.dataTest,
      children = _ref2.children;
  return React.createElement(StyledTableRow, {
    dataTest: dataTest
  }, children);
};

export default TableRow;